"use client";
import { useEffect } from "react";
import Link from "next/link";
import { buttonClass } from "@/components/ui/button";

// 어드민 라우트 세그먼트 에러 바운더리 — 런타임 오류 시 어드민 셸 안에서 복구 UI.
export default function AdminError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("admin route error", error);
  }, [error]);
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <div className="text-3xl">⚠️</div>
      <div>
        <h1 className="text-lg font-semibold">문제가 발생했습니다</h1>
        <p className="mt-1 text-sm text-neutral-500">
          예기치 못한 오류로 이 화면을 표시할 수 없습니다.
          {error.digest && <span className="ml-1 font-mono text-xs text-neutral-400">({error.digest})</span>}
        </p>
      </div>
      <div className="flex gap-2">
        <button onClick={reset} className={buttonClass({ size: "sm" })}>다시 시도</button>
        <Link href="/" className={buttonClass({ variant: "outline", size: "sm" })}>대시보드로</Link>
      </div>
    </div>
  );
}
